import React from 'react';
import {
  string, arrayOf, objectOf, element, number, bool
} from 'prop-types';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { Typography } from '@one-thd/sui-atomic-components';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { getGridColumnsClassName, publish } from '../utils';

const CapabilitiesRow = ({
  children,
  id,
  title,
  customRenderId,
  __typename,
  hydrationOptions,
  proAnalyticsData
}) => {
  const { SCROLL_BUFFER, DELAY = 250, PLACEHOLDER, immediateRender } = hydrationOptions;

  const triggerAnalytics = (campaign, index) => {
    const widgetData = {
      widgetId: id,
      widgetComponent: 'C' + index,
      widgetCampaign: campaign?.replaceAll('&', 'and')
    };
    if (proAnalyticsData.isB2B) {
      widgetData.widgetTemplates = proAnalyticsData.templates;
    }
    publish(widgetData);
  };
  return (
    <Hydrator
      id={`thd-capabilities-php-hydrator-${id}`}
      className="sui-h-full"
      scrollBuffer={SCROLL_BUFFER}
      delay={DELAY}
      placeholder={PLACEHOLDER}
      immediateRender={immediateRender}
    >
      <ImpressionProvider
        data={{
          id,
          name: customRenderId,
          component: __typename,
          type: 'content',
        }}
      >
        {title && (
          <div className="sui-my-4">
            <Typography
              variant="h2"
              weight="condensed"
              height="snug"
              color="primary"
            >
              {title}
            </Typography>
          </div>
        )}
        <div
          key={id}
          className={getGridColumnsClassName(children)}
          data-component="CapabilitiesRow"
        >
          {
                 React.Children?.map(children, (child, index) => {
                   return (
                     <div
                       onClick={() => triggerAnalytics(child?.title, index + 1)}
                       role="button"
                       key={index}
                       tabIndex={0}
                     >
                       {child}
                     </div>
                   );
                 })
          }
        </div>
      </ImpressionProvider>
    </Hydrator>
  );
};

CapabilitiesRow.propTypes = {
  id: string.isRequired,
  title: string,
  customRenderId: string.isRequired,
  __typename: string,
  children: arrayOf(element).isRequired,
  hydrationOptions: objectOf({
    SCROLL_BUFFER: string,
    DELAY: number,
    PLACEHOLDER: element,
    immediateRender: bool
  }),
  proAnalyticsData: objectOf({
    isB2B: bool,
    templates: string
  })
};
CapabilitiesRow.defaultProps = {
  title: null,
  __typename: null,
  hydrationOptions: {},
  proAnalyticsData: {}
};

export { CapabilitiesRow };
